import { useCallback } from 'react';
import { useLocation } from 'react-router';
import { useClientContext } from 'client/context';
import { setCandleWorkers } from 'ducks/candle-workers/slices';
import { updateSettings } from 'ducks/settings/slices';
import { useAppDispatch } from 'store/hooks';
import { parseQuery } from 'utils/queries';

import { JobsQuery } from './types';

const useCandleWorkersApi = () => {
  const { search } = useLocation();
  const dispatch = useAppDispatch();
  const { Voladeum, handleError } = useClientContext();

  const getData = useCallback(async () => {
    try {
      dispatch(updateSettings({ loading: true }));
      const { candle_worker_adapter_ids, candle_worker_status_ids, candle_worker_pair_ids } =
        parseQuery<JobsQuery>(search);

      const [voladeum_candle_workers] = await Promise.all([
        Voladeum.candleWorkers.list({
          adapter_ids: candle_worker_adapter_ids || [],
          status_ids: candle_worker_status_ids || [],
          pair_ids: candle_worker_pair_ids || [],
        }),
      ]);

      dispatch(setCandleWorkers(voladeum_candle_workers.data));
      dispatch(updateSettings({ loading: false }));
    } catch (err) {
      handleError(err);
    }
  }, [dispatch, search, Voladeum, handleError]);

  return { getData };
};

export { useCandleWorkersApi };
